export const prefix = "I need you to analyze the data below. \n";
export const suffix = `

I need your assistance in building a chart using the Chart.js library. Here are the criteria:

1. Analyze the provided data and generate the code for a chart that accurately represents the data. The HTML file will contain a div element with the ID 'chart-generator'.
2. Please provide only the chart script without the script tags. Avoid including any additional text in the response for this request.
3. If any numbers in the data have leading zeros, remove the zeros from the front of the number.
4. Avoid including the 'getContext('2d')' function, as the 'ctx' variable already exists.
5. Ensure to use distinctive colors in the chart using these colors: #007680, #0097A9, #6FC2B4, #005587, #0076A8, #62B5E5, #2C5234, #C4D600, #007CB0, #26890D, #43B02A, #ED8B00, #FFCD00. 
6. Please follow the below example as the output:

//scriptstart

{{output script goes here}}

//scriptend

`;

export const getInsights = `\n\n  \n\n

Please analyze the provided data and uncover valuable insights and meaningful patterns that can summarize the input data. 
The output must and should follow criteria.
Ouput of my question should be a FULL HTML with the following structure:

<html>
    <h4 class="h4">{{one line insightful heading of the input data goes here}}</h4>
    <ul>
        <li>
            <b>{{ Summary of the bullet point in not more than 4 words should be displayed here. </b>
            <div>{{Insights summary of the input data should be displayed here in each bullet point. Summarize the insights with atleast 5 bullet points. }} </div>
        </li>
    </ul>
    <span><b><i>Key fact: </i></b></span><h6 style="color:#007CB0;">{{should contain a fun fact about the input data with subtle humor, no more than 30 words. Color this text blue}}</h6>
</html>

`;

export const separator = `\n\n \n\n Also please do not add any additional text like "Sure, I can help you with that."`;
